import { netlifyImages } from "../data/netlifyImages";

export const convertToSlug = (Text) => {
  return Text.toLowerCase()
    .replace(/[^\w ]+/g, "")
    .replace(/ +/g, "-");
};

export const exhibitionLocations = [
  "Roylston Street",
  "Neild Avenue",
  "Elizabeth Street",
  "Lennox Street",
];

export const ucUrlToNetlifyUrl = (url) => {
  // Convert Uploadcare URL to Netlify URL
  // From https://ucarecdn.com/054eed4e-fc3c-4d03-98c3-9b0093e7b733/xyz or https://ucarecdn.com/054eed4e-fc3c-4d03-98c3-9b0093e7b733
  // To https://scg-images.netlify.app/.netlify/images?url=/054eed4e-fc3c-4d03-98c3-9b0093e7b733.jpg
  // Step 1: Extract the UUID from the URL
  const parts = url.split("/");
  const uuid = parts[3];
  // Step 2: Find the file name from netlifyImages.json by searching for the matching UUID and then getting the file name
  const file = netlifyImages.find((img) => img["UUID"] === uuid);
  if (file) {
    const fileName = file["fileName"];
    // Step 3: Construct the new URL
    return `https://scg-images.netlify.app/.netlify/images?url=/${fileName}`;
  } else {
    // If no matching file is found, return the original URL
    return "https://placehold.co/600x400";
  }
};
